export const AMPLITUDE_EVENT_NAMES = {
  CHECKOUT_STARTED: 'Checkout Started'
};
